module.exports = __webpack_public_path__ + "static/media/uspto.145c056d.jpg";